<template>
  <span class="k-chip" :style="{ '--k-chip-color': tone }">
    <slot>{{ label }}</slot>
  </span>
</template>

<script>
const THEME_COLORS = ["primary", "accent", "secondary", "success", "info", "warning", "error", "neutral"];

export default {
  name: "KChip",
  props: {
    color: {
      type: String,
      default: "primary",
    },
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    tone() {
      if (THEME_COLORS.includes(this.color)) return `rgb(var(--v-theme-${this.color}))`;
      return this.color;
    },
  },
};
</script>

<style scoped>
.k-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.5;
  white-space: nowrap;
  color: color-mix(in srgb, var(--k-chip-color) 78%, rgb(var(--v-theme-on-surface)));
  background: color-mix(in srgb, var(--k-chip-color) 14%, transparent);
  border: 1px solid color-mix(in srgb, var(--k-chip-color) 22%, transparent);
}
</style>
